var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9239 3.93339L21.8555 19.4034C22.2662 20.1146 21.7525 21.0036 20.9319 21.0036H3.06875C2.24748 21.0036 1.73384 20.1146 2.14447 19.4034L11.0761 3.93339C11.4867 3.22219 12.5133 3.22219 12.9239 3.93339Z",
    fill: "#DC0451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9978 8.42636H13.0446V12.4628C13.0446 12.896 13.0185 13.325 12.967 13.7505C12.9155 14.1766 12.847 14.6105 12.7623 15.0522H11.2807C11.196 14.6098 11.1276 14.1759 11.0761 13.7505C11.0246 13.325 10.9985 12.8953 10.9985 12.4628L10.9978 8.42636ZM13.1469 18.0769C13.0834 18.2251 12.9952 18.3535 12.8823 18.4614C12.7694 18.5694 12.6375 18.6541 12.4872 18.7154C12.3369 18.7768 12.1739 18.8072 12.0004 18.8072C11.8218 18.8072 11.6567 18.7768 11.5065 18.7154C11.3555 18.6541 11.2249 18.5694 11.1149 18.4614C11.0041 18.3535 10.9173 18.2251 10.8538 18.0769C10.7903 17.9288 10.7586 17.77 10.7586 17.6007C10.7586 17.4313 10.7903 17.274 10.8538 17.128C10.9173 16.9819 11.0041 16.8549 11.1149 16.747C11.2257 16.639 11.3562 16.5529 11.5065 16.4894C11.6567 16.4259 11.8218 16.3942 12.0004 16.3942C12.1746 16.3942 12.3369 16.4259 12.4872 16.4894C12.6375 16.5529 12.7694 16.639 12.8823 16.747C12.9952 16.8549 13.0834 16.9826 13.1469 17.128C13.2104 17.274 13.2421 17.4313 13.2421 17.6007C13.2421 17.77 13.2104 17.9288 13.1469 18.0769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.834663636ae326266d62914ed7483f49.svg";
export { ForwardRef as ReactComponent };